<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">角色修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="addForm" :rules="rules" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="addForm.name" v-if="addForm.name != '机构管理员' " ></el-input>
                                    <el-input v-model="addForm.name" v-if="addForm.name == '机构管理员' " disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model="addForm.sort"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜单" required>
                                    <el-tree
                                            :data="listMenuDTO"
                                            show-checkbox
                                            default-expand-all
                                            node-key="menuCode"
                                            ref="tree"
                                            highlight-current
                                            :props="defaultProps">
                                    </el-tree>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,

                listMenuDTO:[],
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    sort:'',
                    roleCode:'',
                    listMenu:[],

                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                    ],

                }

            }
        },

        methods: {

            init(row){
                console.log(row);
                this.addForm.name = row.name;
                this.addForm.sort = row.sort;
                this.addForm.roleCode = row.roleCode;

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Menu/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        console.log(JSON.stringify(response.data));
                        if (response.data.error == 0) {
                            this.listMenuDTO = response.data.data.listMenuDTO;
                            this.checkedNode(row.listMenu);
                        }
                    }
                )

            },


            isLast(arr,menuCode){
                for(var i=0;i<arr.length;i++){
                    var item = arr[i];
                    if(item.parentMenuCode == menuCode){
                        return false;
                    }
                }
                return true;
            },

            checkedNode(listMenu){
                var getArr = [];
                var arr = listMenu;
                for(var i=0;i<arr.length;i++){
                    if(this.isLast(listMenu,arr[i].menuCode)){
                        getArr.push(arr[i].menuCode);
                    }
                }
                this.$nextTick(function(){
                    this.$refs.tree.setCheckedKeys(getArr);
                })
                console.log(getArr)
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){

                        let array1 = []; //一级数组
                        let array2 = []; //二级数组

                        let nodes = this.$refs.tree.getCheckedNodes(false,true);
                        console.log(nodes);
                        //分开1级菜单
                        for(let i = 0; i<nodes.length;i++){
                            let list1 = {
                                menuCode:nodes[i].menuCode,
                                parentMenuCode:nodes[i].parentMenuCode,
                                name:nodes[i].name,
                                listMenu:[]
                            };
                            if(nodes[i].parentMenuCode == "00000000-0000-0000-0000-000000000000"){
                                array1.push(list1);
                            }else {
                                array2.push(list1);
                            }
                        }
                        console.log(array1);
                        console.log(array2);
                        //分开2级菜单，
                        for(let k in array1){
                            for(let j in array2){
                                let list2 = {
                                    menuCode:array2[j].menuCode,
                                    parentMenuCode:array2[j].parentMenuCode,
                                    name:array2[j].name,
                                    listMenu:[]
                                };
                                if(array2[j].parentMenuCode == array1[k].menuCode){
                                    array1[k].listMenu.push(list2);
                                }

                            }
                        }
                        console.log(array1);
                        for(let n in array1){
                            for(let m in array1[n].listMenu){
                                for (let l in array2){
                                    let list3 = {
                                        menuCode:array2[l].menuCode,
                                        parentMenuCode:array2[l].parentMenuCode,
                                        name:array2[l].name,
                                        listMenu:[]
                                    };
                                    if(array1[n].listMenu[m].menuCode == array2[l].parentMenuCode){
                                        array1[n].listMenu[m].listMenu.push(list3);
                                    }
                                }
                            }
                        }
                        console.log("数组1："+JSON.stringify(array1));
                        this.addForm.listMenu = array1;
                        if(this.addForm.listMenu ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Role/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
